<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title class="me-3 mb-5">{{ _timelineHeader }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @for (item of _timelineItems; track $index) {
      <div
        class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
        >
        <div
          class="vertical-timeline-item vertical-timeline-element">
          <div>
            <span class="vertical-timeline-element-icon">
              <i class="badge"
              [ngClass]="item.iconStyles ? item.iconStyles : 'bg-primary'">&nbsp;</i>
            </span>
            <div class="vertical-timeline-element-content bounce-in">
              <h4 class="timeline-title">{{item.title}}</h4>
              <p>{{item.description}}</p>
              <span class="vertical-timeline-element-date">{{item.date}}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>